<template>
  <div :key="key" class="dashboard-chart">
    <h4 class="titulo">Rentabilidad Bruta</h4>
    <!-- <h4 :class="totalNegocio ? 'titulo' : ''">Rentabilidad Bruta</h4> -->
    <p v-if="!totalNegocio" class="subtitulo">No incluye reembolsos</p>
    <vue-svg-gauge
      :start-angle="-110"
      :end-angle="110"
      :value="indicadorRentabilidadValue"
      :separator-step="parseInt(0)"
      :min="indicadorRentabilidadMin"
      :max="indicadorRentabilidadMax"
      :gauge-color="indicadorRentabilidadColor"
      :scale-interval="10"/>
    
    <chart-avance :pjeAvance="indicadorPjeAvancePeriodo" />

    <div class="dashboard-chart-text">
      <p>Objetivo: {{ indicadorRentabilidadObjetivo | numero(2, true) }} %</p>
      <p>Rentabilidad: {{ indicadorRentabilidadValue | numero(2, true) }} %</p>
      <p>Rent.Anual: {{ indicadorRentabilidadAnualValue | numero(2, true) }} %</p>
      <p class="description">Rentabilidad promedio ponderada</p>
      <p class="description">{{ indicadorRentabilidadDescripcion }}</p>
      <p class="description">Cant.Presupuestos: {{ indicadorPresupuestos }}</p>
      <p class="link" 
        @click.stop="exportarPresupuestos" v-if="exportHabilitado && accesoExportar"><i class="fa fa-file-excel-o"></i>Exportar Presupuestos</p>
      <p class="link" 
        @click.stop="actualizarResultados" v-if="accesoActualizar"><i class="fa fa-undo"></i>Actualizar Resultados</p>
    </div>
  </div>
</template>

<script>
import { VueSvgGauge } from 'vue-svg-gauge';
import ChartAvance from './ChartAvance.vue';

export default {
  components: {
    VueSvgGauge,
    ChartAvance
  },
  props: {
    totalNegocio: {
      type: Boolean,
      default: false
    },
    accesoExportar: {
      type: Boolean,
      default: false
    },
    accesoActualizar: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      rojo: '#E46651',
      verde: '#41B883',
      amarillo: '#FAFA05',
      rosa: '#FF0187',

      key: 0,
      indicadorRentabilidadColor: [ { offset: 0, color: '#E46651' }, { offset: 100, color: '#E46651' } ],
      // indicadorRentabilidadNetaColor: [
      //   { offset: 0, color: '#E46651' },
      //   { offset: 20, color: '#41B883' },
      //   { offset: 100, color: '#41B883' }
      // ],
      indicadorRentabilidadMin: 0,
      indicadorRentabilidadMax: 100,
      indicadorRentabilidadObjetivo: 0,
      indicadorRentabilidadValue: 0,
      indicadorRentabilidadAnualValue: 0,
      indicadorRentabilidadDescripcion: '',
      indicadorPresupuestos: 0,
      indicadorPjeAvancePeriodo: 0,
      
      exportHabilitado: false,
    }
  },
  created() {
  },
  methods: {
    getIndicador() {
      let dispatch = 'resultadosRentabilidadBruta/getIndicadorRentabilidad';
      let getter = 'resultadosRentabilidadBruta/indicadorRentabilidad';

      if ( (/true/i).test(this.totalNegocio)) {
        dispatch = 'resultadosRentabilidadBruta/getIndicadorRentabilidadTotal';
        getter = 'resultadosRentabilidadBruta/indicadorRentabilidadTotal';
      }

      this.$store.dispatch(dispatch)
        .then(() => {
          let indicador = this.$store.getters[getter];

          this.indicadorRentabilidadObjetivo = parseFloat(indicador.pjeObjetivo);
          this.indicadorRentabilidadValue = indicador.pjeRentabilidad;
          this.indicadorRentabilidadAnualValue = indicador.pjeRentabilidadAnual;
          this.indicadorRentabilidadDescripcion = indicador.indicadorPeriodo? indicador.indicadorPeriodo.trim() : '';
          // this.indicadorRentabilidadDescripcion = indicador.descripcion? indicador.descripcion.trim() : '';
          this.indicadorPresupuestos = parseInt(indicador.presupuestos);

          /* Si supera el objetivo, actualizamos el color del indicador */
          if ( parseFloat(this.indicadorRentabilidadValue) >= parseFloat(this.indicadorRentabilidadObjetivo)) {
            this.indicadorRentabilidadColor = [ { offset: 0, color: this.verde }, { offset: 100, color: this.verde } ];
          } else if ( parseFloat(this.indicadorRentabilidadValue) >= (parseFloat(this.indicadorRentabilidadObjetivo) / parseFloat(2))) {
            this.indicadorRentabilidadColor = [ { offset: 0, color: this.amarillo }, { offset: 100, color: this.amarillo } ];
          }
          
          this.indicadorPjeAvancePeriodo = indicador.pjeAvancePeriodo;

          this.exportHabilitado = true;
        })
        .finally(() => this.key++);
    },
    exportarPresupuestos() {
      let dispatch = 'resultadosRentabilidadBruta/getPresupuestosIndicadorRentabilidad';

      if ( (/true/i).test(this.totalNegocio)) {
        dispatch = 'resultadosRentabilidadBruta/getPresupuestosIndicadorRentabilidadTotal';
      }

      this.showSpinner();
      this.$store.dispatch(dispatch)
        .then(() => {
          let exportRpt = Boolean(false); 
          let presupuestos = this.$store.getters['resultadosRentabilidadBruta/resultadosIndicadorRentabilidad'];

          if (presupuestos) {
            if (presupuestos.length != 0) {
              exportRpt = Boolean(true);
            }
          }
          if (exportRpt) {
            let title= 'Detalle de Presupuestos';
            let fileName = 'rentabilidad-bruta';
            let format = [
              { titulo: 'Nro.Presupuesto', nombre: 'numero', formato: '' },
              { titulo: 'Cliente', nombre: 'cliente', formato: '' },
              { titulo: 'Accion', nombre: 'accion', formato: '' },
              { titulo: 'Neto Total', nombre: 'cotizacion', formato: '' },
              { titulo: 'Costo Real', nombre: 'costo', formato: '' },
              { titulo: 'Pje.Rentabilidad', nombre: 'pjeRentabilidad', formato: '' },
            ];

            this.exportXLS(title, fileName, presupuestos, format);

          } else {
            console.log('No hay datos para exportar.');
          }
        })
        .catch(error => {
          console.log(error);
        })
        .finally(() => this.hideSpinner());
    },
    actualizarResultados() {
      this.showSpinner();
      this.$store.dispatch('resultadosRentabilidadBruta/actualizarResultadosIndicadorRentabilidad')
        .then(() => this.getIndicador())
        // .catch(error => this.showErrorMsj(error))
        .catch(error => console.dir(error))
        .finally(() => this.hideSpinner());      
    }
  }
}
</script>

<style>
</style>


